module.exports = __webpack_public_path__ + "static/media/CBN-Network.540b764d.gif";